import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="not-found-page">
      <div className="text-center">
        <p className="text-7xl font-display font-bold text-gold mb-2">404</p>
        <h1 className="text-xl font-semibold mb-2">Page Not Found</h1>
        <p className="text-sm text-muted-foreground mb-6">The page you're looking for doesn't exist or has been moved.</p>
        <Button onClick={() => navigate('/')} data-testid="go-home-button">Go to Dashboard</Button>
      </div>
    </div>
  );
}
